export default {"src":"/_next/static/media/googleMeet.1ac57fc5.svg","height":72,"width":88,"blurWidth":0,"blurHeight":0};